import { fork, all } from 'redux-saga/effects';

import globalSaga from './containers/Full/sagas'
import dashboardSaga from './views/Dashboard/sagas'
import loginSaga from './views/Pages/Login/sagas'
import loginMfaSaga from './views/Pages/LoginMfa/sagas'
import resendConfirmRegistSaga from './views/Pages/ResendConfirmAcc/sagas'
import confirmRegistAccSaga from './views/Pages/ActiveAcc/sagas'
import forgotPasswordSaga from './views/Pages/ResendResetPwCode/sagas'
import resetPasswordSaga from './views/Pages/ResetPassword/sagas'
import changePasswordSaga from './views/Pages/ChangePassword/sagas'
import twoFASettingSaga from './views/Pages/TwoFASetting/sagas'
import registerSaga from './views/Pages/Register/sagas'
import profileSaga from './views/Pages/MyAccount/sagas'
import headerSaga from './components/Header/sagas'
import sidebarSaga from './components/Sidebar/sagas'
import statsSaga from './components/Stats/sagas'
import chartSaga from './components/Chart/sagas'
import chart2Saga from './components/Chart2/sagas'
import clientSaga from './views/client/sagas'
import adminUserSaga from './views/Admin/AdminUser/sagas'
import userAdSaga from './views/Admin/UserAd/sagas'
import activitiesSaga from './views/Admin/ActivityLog/sagas'

import roleSaga from './views/Role/sagas'
import nhapkhoSaga from './views/NhapKho/sagas'
import lsnhapkhoSaga from './views/LsNhapKho/sagas'
import nganhHangSaga from './views/NganhHang/sagas'
import nhomKhachHangSaga from './views/NhomKhachHang/sagas'
import nhaCungCapSaga from './views/NhaCC/sagas'
import khoSaga from './views/Kho/sagas'
import productsSaga from './views/Products/sagas'
import khachhangSaga from './views/KhachHang/sagas'
import nguoiDungKhoSaga from './views/NguoiDungKho/sagas'
import chuongTrinhSaga from './views/ChuongTrinh/sagas'
import khachHangNhomSaga from './views/KhachHangNhom/sagas'
import nguoiDungRoleSaga from './views/NguoiDungRole/sagas'
import permissionRoleSaga from './views/PermissionRole/sagas'
import ordersSaga from './views/Orders/sagas'
import orderSaga from './views/Order/sagas'
import marketingOrdersSaga from './views/MarketingOrders/sagas'
import marketingOrderSaga from './views/MarketingOrder/sagas'
import tonKhoSaga from './views/TonKho/sagas'
import guestReportSaga from './views/Reports/GuestReport/sagas'
import importReportSaga from './views/Reports/ImportReport/sagas'
import orderReportSaga from './views/Reports/OrderReport/sagas'
import salaryReportSaga from './views/Reports/SalaryReport/sagas'
import salaryReportDetailSaga from './views/Reports/SalaryReportDetail/sagas'
import saleDetailReportSaga from './views/Reports/SaleDetailReport/sagas'
import saleTotalReportSaga from './views/Reports/SaleTotalReport/sagas'
import saleReportSaga from './views/Reports/SaleReport/sagas'
import giaoHangReportSaga from './views/Reports/GiaoHangReport/sagas'
import giaoHangSaga from './views/GiaoHang/sagas'
import congNoKhSaga from './views/CongNoKhachHang/sagas'
import hopDongSaga  from './views/HopDong/sagas'
import traHangSaga  from './views/TraHang/sagas'
import settingSaga  from './views/Setting/sagas'
import bacLuongSaga from './views/BacLuong/sagas'
import congNoNhanVienSaga from './views/CongNoNhanVien/sagas'
import lichSuThanhToanSaga from './views/LichSuThanhToan/sagas'
import profitReportSaga from './views/Reports/ProfitReport/sagas'
import checkinSaga  from './views/Checkin/sagas'
import lichSuTraThuongSaga from './views/LichSuTraThuong/sagas'

export default function* rootSaga(store) {
  yield all([
    fork(globalSaga),
    fork(loginSaga),
    fork(resendConfirmRegistSaga),
    fork(confirmRegistAccSaga),
    fork(forgotPasswordSaga),
    fork(resetPasswordSaga),
    fork(registerSaga),
    fork(headerSaga),
    fork(dashboardSaga),
    fork(profileSaga),
    fork(changePasswordSaga),
    fork(twoFASettingSaga),
    fork(loginMfaSaga),
    fork(clientSaga),
    fork(adminUserSaga),
    fork(userAdSaga),
    fork(activitiesSaga),
    fork(sidebarSaga),
    fork(statsSaga),
    fork(chartSaga),
    fork(roleSaga),
    fork(nhapkhoSaga),
    fork(lsnhapkhoSaga),
    fork(nganhHangSaga),
    fork(nhomKhachHangSaga),
    fork(nhaCungCapSaga),
    fork(khoSaga),
    fork(productsSaga),
    fork(nguoiDungKhoSaga),
    fork(chuongTrinhSaga),
    fork(khachHangNhomSaga),
    fork(nguoiDungRoleSaga),
    fork(khachhangSaga),
    fork(ordersSaga),
    fork(orderSaga),
    fork(marketingOrdersSaga),
    fork(marketingOrderSaga),
    fork(tonKhoSaga),
    fork(guestReportSaga),
    fork(importReportSaga),
    fork(orderReportSaga),
    fork(saleDetailReportSaga),
    fork(saleTotalReportSaga),
    fork(saleReportSaga),
    fork(giaoHangSaga),
    fork(congNoKhSaga),
    fork(permissionRoleSaga),
    fork(hopDongSaga),
    fork(traHangSaga),
    fork(chart2Saga),
    fork(settingSaga),
    fork(giaoHangReportSaga),
    fork(bacLuongSaga),
    fork(salaryReportSaga),
    fork(salaryReportDetailSaga),
    fork(congNoNhanVienSaga),
    fork(lichSuThanhToanSaga),
    fork(profitReportSaga),
    fork(checkinSaga),
    fork(lichSuTraThuongSaga)
  ])
}



// WEBPACK FOOTER //
// ./src/index-sagas.js